import React from 'react'
import { Form, Grid } from 'semantic-ui-react'
import LotMatchingInstructions from './LotMatchingInstructions'
import SpecialInstructions from './SpecialInstructions'
import styles from './styles.module.less'
import { TradeFormErrors, TradeFormTouched, TradeFormValues } from './Types'

export interface TradeInstructionsWrapperProps {
  errors: TradeFormErrors
  touched: TradeFormTouched
  values: TradeFormValues
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

const TradeInstructionsWrapper = ({ errors, setFieldValue, touched, values }: TradeInstructionsWrapperProps) => {
  return (
    <div className={styles.tradeInstructionsWrapper}>
      <Form>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <SpecialInstructions values={values} setFieldValue={setFieldValue} />
            </Grid.Column>
            <Grid.Column>
              <LotMatchingInstructions
                errors={errors}
                touched={touched}
                values={values}
                setFieldValue={setFieldValue}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
  )
}

export default TradeInstructionsWrapper
